import { ProductModel } from './../../models/product.model';
import { Subject } from "rxjs";
import {
  Component,
  Input, 
  Output,
  OnInit,
  EventEmitter
} from '@angular/core';
import { ModelModel } from "../../models/model.model";

declare const loadRebates: any;

@Component({
  selector: 'app-model-details-rebate',
  templateUrl: './model-details-rebate.component.html',
  styleUrls: ['./model-details-rebase.component.scss']
})
export class ModelDetailsRebateComponent implements OnInit {
  product: ProductModel;
  model: ModelModel;
  modelNumber: string;
  modalVisibility: boolean = false;
  @Input() rebatesInputEvent: Subject<any>;
  rebatesVisible: boolean = false;
  zipEvent: Subject<string> = new Subject<string>();
  @Output() newZipEvent: EventEmitter<string> = new EventEmitter<string>();

  // fields to be displayed dynamically
  rebate: any;
  amount: string = "";
  zip: string = "";
  cityState: string = "";
  homeName: string = "";
  homeUrl: string = "";
  buyAfter: string = "";
  buyBefore: string = "";
  claimBy: string = "";
  claimWithin: string = "";
  offerType: string = "";
  claimFormURL: string = "";
  importantDetails: string[] = [];

  ngOnInit(): void {
    if (this.rebatesInputEvent) {
      this.rebatesInputEvent.subscribe(response => {
        if (typeof response !== "string") {
          this.setRebate(response);
          this.rebatesVisible = true;
        }
        else {
          this.zipEvent.next(response);
          this.rebatesVisible = false;
          this.cityState = "";
        }
      })
    }
  }

  setZipCode(zip: string) {
    if (zip !== this.zip) {
      this.zip = zip;
      this.zipEvent.next(this.zip);
      this.newZipEvent.next(this.zip);
    }
  }

  setRebate = (response) => {
    if (
      response &&
      response.EcoRebatesResponse && 
      response.EcoRebatesResponse.productRebateDetails.length > 0 &&
      response.EcoRebatesResponse.productRebateDetails[0].rebatePrograms.length > 0
    ) {
      this.rebate = response.EcoRebatesResponse.productRebateDetails[0];
      
      this.amount = this.rebate.rebatePrograms[0].amountLabel;
      this.homeName = this.rebate.rebatePrograms[0].name;
      this.homeUrl = this.rebate.rebatePrograms[0].homeURL;
      this.buyAfter = this.rebate.rebatePrograms[0].purchaseDates.buyAfter;
      this.buyBefore = this.rebate.rebatePrograms[0].purchaseDates.buyBefore;
      this.claimBy = this.rebate.rebatePrograms[0].purchaseDates.claimBy;
      this.claimWithin = this.rebate.rebatePrograms[0].purchaseDates.claimWithin;
      this.importantDetails = this.rebate.rebatePrograms[0].importantDetails;
      this.claimFormURL = this.rebate.rebatePrograms[0].claimFormURL;
      this.offerType = this.rebate.rebatePrograms[0].offerTypes[0];
    } 
    else {
      this.rebate = null;
    }
    this.zip = response.EcoRebatesResponse.area.zipCodePadded;
    this.cityState = response.EcoRebatesResponse.area.cityState;
    this.zipEvent.next(this.zip);
  }

  submitRebate = () => {
    window.open(this.claimFormURL, "_blank");
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/components/eco-rebates/model-details-rebate.component.ts